module.exports = __webpack_public_path__ + "assets/stickeryo_logo-259eb3284df8504e46e076c6df89ae80.png";